import { EnvironmentModel } from '@env/environment-model';

export const getUrlConfig: (
  prefixIdentity: string,
  prefixCustoms: string,
  prefixFreight: string,
  prefixInsurance: string,
  provider: string,
) => EnvironmentModel['url'] = (
  prefixIdentity: string,
  prefixCustoms: string,
  prefixFreight: string,
  prefixInsurance: string,
  provider: string,
) => ({
  provider: provider,
  prefixIdentity: prefixIdentity,
  prefixCustoms: prefixCustoms,
  prefixFreight: prefixFreight,
  prefixInsurance: prefixInsurance,
  user: prefixIdentity + 'users/',
  isf: prefixCustoms + 'isf/',
  isfs: prefixCustoms + 'v2/isfs/',
  isfsInsurance: prefixInsurance + 'v2/isfs/',
  isfEntities: prefixCustoms + 'isfentities/',
  bankPayments: prefixCustoms + 'v2/bank-payments',
  entities: prefixCustoms + 'entities/',
  organizations: prefixCustoms + 'v2/organizations/',
  organizationInvitations: prefixCustoms + 'v2/organization-invitations/',
  companies: prefixCustoms + 'v2/companies/',
  companiesV3: prefixCustoms + 'v3/companies/',
  favoriteHts: prefixCustoms + 'v2/favorite-hts-numbers/',
  code: prefixIdentity + 'code/',
  vessel: `${prefixCustoms}vessel`,
  bond: prefixCustoms + 'bond/',
  shipment: `${prefixCustoms}shipment/`,
  isfManagement: prefixCustoms + 'v3/management/isfs/',
  esInsurance: prefixInsurance + 'v2/entry-summaries/',
  esManagement: prefixCustoms + 'v2/management/entry-summaries/',
  organizationsManagement: prefixCustoms + 'v2/management/organizations/',
  companiesManagement: prefixCustoms + 'v2/management/companies/',
  userManagement: prefixIdentity + 'v2/management/users/',
  bondsManagement: prefixCustoms + 'v2/management/bonds/',
  bondRequestsManagement: prefixCustoms + 'v2/management/bond-requests/',
  businessIntelligence: prefixCustoms + 'business-intelligence/',
  betaFeaturesManagement: prefixCustoms + 'v2/management/beta-features/',
  bluesnap: prefixCustoms + 'v2/bluesnap/',
  linesManagement: prefixCustoms + 'v2/management/lines/',
  stripe: prefixCustoms + 'v2/stripe/',
  paypalVault: prefixCustoms + 'v2/paypal-vault/',
  freight: {
    companies: prefixFreight + 'v2/companies',
    companiesV3: prefixFreight + 'v3/companies',
    routes: prefixFreight + 'routes',
    routesManagement: prefixFreight + 'management/routes',
    voyages: prefixFreight + 'voyages',
    voyagesManagement: prefixFreight + 'management/voyages',
    containerStoragesManagement: prefixFreight + 'management/container-freight-storages',
    containerStorageManagersManagement: prefixFreight + 'management/container-freight-storages-managers',
    containersManagement: prefixFreight + 'management/containers',
    containerTypesManagement: prefixFreight + 'management/container-types',
    containerSealsManagement: prefixFreight + 'management/container-seals',
    masterBillsManagement: prefixFreight + 'management/master-bills',
    houseBillsManagement: prefixFreight + 'management/house-bills',
    packingListsManagement: prefixFreight + 'management/packing-lists',
    packingListItemsManagement: prefixFreight + 'management/packing-list-items',
    quotes: prefixFreight + 'quotes',
    quotesManagement: prefixFreight + 'management/quotes',
    quotesManualManagement: prefixFreight + 'management/manual-quotes',
    shipmentsManagement: prefixFreight + 'management/shipments',
    shipments: prefixFreight + 'shipments',
    packages: prefixFreight + 'packages',
    agents: prefixFreight + 'management/agents',
    agentsPriceLists: prefixFreight + 'management/agent-pricelists',
    subcostNames: prefixFreight + 'management/subcost-names',
    additionalShipmentPayments: prefixFreight + 'management/additional-shipment-payments',
    combinedPriceList: prefixFreight + 'management/combined-pricelists',
    combinedSubcost: prefixFreight + 'management/combined-pricelists-subcosts',
  },
});
